export enum EFamily {
  Room = "Room",
  Set = "Set",
  Equipment = 'Equipment',
}
